import { defineStore } from 'pinia'
import onboardingServices from '@/api/services/onboardingServices'
import { ref, reactive } from 'vue'

export const useOnboardingStore = defineStore('onboardingStore', () => {
  const hasAccessToSecondStep = ref(false)
  const isOnboardingSuccess = ref(false)
  const initial_stage_country_name = ref('')
  const onboardingData = reactive({
    initial_stage_country: '',
    initial_stage_name: '',
    initial_stage_slug: '',
    first_name: '',
    last_name: '',
    language: '',
    nickName: '',
    email: '',
    password: '',
    subscribed: false
  })

  const setStageFormData = ({
    initial_stage_country,
    initial_stage_name,
    initial_stage_slug,
    initial_stage_country_name: countryName
  }) => {
    Object.assign(onboardingData, {
      initial_stage_country,
      initial_stage_name,
      initial_stage_slug
    })
    initial_stage_country_name.value = countryName
  }

  const setAccountFormData = ({
    firstName,
    lastName,
    language,
    nickName,
    email,
    password,
    subscribed
  }) => {
    Object.assign(onboardingData, {
      firstName,
      lastName,
      language,
      nickName,
      email,
      password,
      subscribed
    })
  }

  const saveStageFormData = (payload) => {
    setStageFormData(payload)
    hasAccessToSecondStep.value = true
  }

  const saveAccountFormData = async (payload, isOnboarding) => {
    setAccountFormData(payload)
    await register(isOnboarding)
  }

  const register = async (isOnboarding) => {
    if (isOnboarding) {
      await onboardingServices.onboardingArtist(onboardingData)
    } else {
      await onboardingServices.registerArtist(onboardingData)
    }
    isOnboardingSuccess.value = true
  }

  const confirmArtist = async (emailConfirmationToken) => {
    return await onboardingServices.confirmArtistEmail(emailConfirmationToken)
  }

  return {
    hasAccessToSecondStep,
    isOnboardingSuccess,
    initial_stage_country_name,
    onboardingData,
    setStageFormData,
    setAccountFormData,
    saveStageFormData,
    saveAccountFormData,
    register,
    confirmArtist
  }
})
